import { render, staticRenderFns } from "./head.vue?vue&type=template&id=60e25205&scoped=true"
import script from "./head.vue?vue&type=script&lang=js"
export * from "./head.vue?vue&type=script&lang=js"
import style0 from "./head.vue?vue&type=style&index=0&id=60e25205&prod&lang=scss&scoped=true"
import style1 from "./head.vue?vue&type=style&index=1&id=60e25205&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e25205",
  null
  
)

export default component.exports